import { header, hero, heroHeight } from '../variables';

const animateHeader = () => {
  if (window.scrollY < heroHeight && !header.classList.contains('scrolled')) {
    header.style.transform = `translateY(-${window.scrollY / 3}px)`;
  } else {
    header.style.transform = `none`;
  }
};

const initHeader = () => {
  let prevScrollYPos = 0;

  const headerScrollHandler = () => {
    if (window.scrollY === 0) {
      header.classList.remove('hide', 'scrolled');
    } else if (window.scrollY > heroHeight) {
      if (window.scrollY < prevScrollYPos) {
        header.classList.remove('hide');
        header.classList.add('scrolled');
      } else {
        header.classList.add('hide');
      }
    }

    prevScrollYPos = window.scrollY;
  };

  headerScrollHandler();
  window.addEventListener('scroll', headerScrollHandler);

  if (window.innerWidth >= 1000 && !!hero) {
    window.addEventListener('scroll', animateHeader);
  }
};

export { initHeader };
